<template>
  <nav class="navbar navbar--default"
    :class="{active: this.active}">
    <div class="container">
      <div class="navbar-header block">
        <a class="navbar-brand"
          href="/"
          :style="`background-image:url(${settings.logo})`">
          <span class="sr-only">{{settings.site_name}}</span>
        </a>
        <button
          ref="navToggleBtn"
          class="navbar-toggle"
          :class="{collapsed: !this.navActive}"
          @click="toggleMenu">
          <span class="sr-only">Open Menu</span>
          <span class="icon-bar top-bar"></span>
          <span class="icon-bar middle-bar"></span>
          <span class="icon-bar bottom-bar"></span>
        </button>
      </div>
    </div>
  </nav>
</template>

<script>
import { get, call } from 'vuex-pathify'

export default {
  data () {
    return {
      scroll: 0
    }
  },
  computed: {
    settings: get('Settings'),
    navActive: get('Interface/navActive'),
    mainScrollCont: get('Interface/mainScrollCont'),
    active: function () {
      return this.scroll > 5
    }
  },
  methods: {
    setNavActive: call('Interface/setNavActive'),
    handleScroll (e) {
      this.scroll = e.target.scrollTop
    },
    toggleMenu: function () {
      this.setNavActive(!this.navActive)
    }
  },
  mounted () {
    this.mainScrollCont.addEventListener('scroll', this.handleScroll)
  },
  destroyed () {
    this.mainScrollCont.removeEventListener('scroll', this.handleScroll)
  }
}
</script>

<style scoped></style>
